import React, { useContext, useEffect, useState } from "react";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import PagePreview from "./Preview";
import ResolveIssue from "./ResolveIssue";
import { FullGridContext } from "..";

export default function FinancialHolds() {
  const defaultOrderBy = { column: "name", asc: true };
  const defaultGridHeader = [
    {
      title: "Registration Number",
      name: "registration_number",
      type: "text",
      filter: true,
    },
    {
      title: "Name",
      name: "name",
      type: "text",
      filter: true,
    },
    {
      title: "Last Name",
      name: "last_name",
      type: "text",
      filter: true,
    },
    {
      title: "Email",
      name: "email",
      type: "text",
      filter: false,
    },
    {
      title: "Filial",
      name: "filial",
      type: "text",
      filter: false,
    },
    {
      title: "Overdue Since",
      name: "overdue_invoice_flagged_at",
      type: "date",
      filter: false,
    },
    {
      title: "Hold Status",
      name: "financial_hold_status",
      type: "text",
      filter: true,
    },
    {
      title: "Pending Invoices",
      name: "pending_invoice_count",
      type: "text",
      filter: false,
    },
    {
      title: "On Promise",
      name: "active_promise_count",
      type: "text",
      filter: false,
    },
    {
      title: "Need Resolution",
      name: "unresolved_invoice_count",
      type: "text",
      filter: false,
    },
  ];

  const {
    accessModule,
    gridData,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setLoadingData,
    setOrderBy,
    setPages,
    setSearch,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "financial_holds"
  );

  const [selected, setSelected] = useState([]);
  const [resolveIssueOpen, setResolveIssueOpen] = useState(false);

  useEffect(() => {
    setActiveFilters([]);
  }, []);

  function handleResolveIssue() {
    const newOpened = !resolveIssueOpen;
    setResolveIssueOpen(newOpened);
    if (!newOpened) {
      setSelected([]);
      loader();
    }
    handleOpened(null);
  }

  const selectionFunctions = [
    {
      title: "Resolve Issue",
      fun: handleResolveIssue,
      icon: "ShieldCheck",
      Page: ResolveIssue,
      opened: resolveIssueOpen,
      setOpened: setResolveIssueOpen,
      selected,
    },
  ];

  async function loader() {
    setLoadingData(true);
    const data = await getData("students/overdue-invoice", {
      limit,
      page,
      orderBy,
      setOrderBy,
      setPages,
      setGridData,
      search,
      setSearch,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });
    if (!data) {
      return;
    }
    const gridDataValues = data.map(
      (
        {
          id,
          registration_number,
          name,
          last_name,
          email,
          overdue_invoice_flagged_at,
          filial,
          financial_hold_status,
          pending_invoice_count,
          active_promise_count,
          unresolved_invoice_count,
        },
        index
      ) => {
        return {
          show: true,
          id,
          fields: [
            registration_number,
            name,
            last_name,
            email,
            filial?.name,
            overdue_invoice_flagged_at,
            financial_hold_status,
            pending_invoice_count,
            active_promise_count,
            unresolved_invoice_count,
          ],
          selectable: true,
          page: Math.ceil((index + 1) / limit),
        };
      }
    );
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
      handleNew={false}
      selection={{
        multiple: false,
        selected,
        setSelected,
        functions: selectionFunctions,
      }}
    />
  );
}
